import TalkviaCalendar from './Index.vue';
import { CALENDAR_ROUTE_PERMISSIONS } from './calendarAccess';

export const routes = [
  {
    path: 'agenda',
    name: 'talkvia_calendar',
    meta: {
      permissions: [...CALENDAR_ROUTE_PERMISSIONS],
    },
    component: TalkviaCalendar,
  },
];
